import { combineReducers } from "redux";
import senderIdListReducer from "./sender_id_list_reducer";

const senderIdReducer = combineReducers({ senderIdList: senderIdListReducer });

export default senderIdReducer;
